export default __webpack_public_path__ + "static/media/404.dff5708b.png";